import React, { useState } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"
import { useDispatch, useSelector } from "react-redux";

//Import images
import avatar3 from "../../../assets/images/users/avatar-3.jpg"
import avatar4 from "../../../assets/images/users/avatar-4.jpg"

//i18n
import { withTranslation } from "react-i18next"
import { useAppSelector } from "store"
import { setSelectedFactory } from "store/slice/factory.slice"

const FactoryDropdown = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  const dispatch = useDispatch()
  // const factories = useSelector((state) => state.factory.factories);
  const selectedFactory = useAppSelector(state => state.factory.selected)
  const factory = useAppSelector(state => state.factory.factories);

  function factorySelect(fac) {
    // props.updateSelectedFactory(fac);
    dispatch(setSelectedFactory(fac));
    setMenu(!menu)
  }

  return (
    <>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn mw-factory-toggle waves-effect"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="bx bxs-factory" style={{ fontSize: '16px' }} />
          {selectedFactory && <span className="d-none d-md-inline-block">{selectedFactory['name']}</span>}
          <i className="mdi mdi-chevron-down" />
        </DropdownToggle>

        <DropdownMenu end className="mw-factory-menu dropdown-menu-end">
          <div className="mw-factory-head">Select factory</div>

          <SimpleBar style={{ maxHeight: "300px" }}>
            {factory &&
              factory.map((fac, index) => {
                const isSelected = (selectedFactory && fac['_id'] === selectedFactory['_id']) ? true : false;
                return (
                  <Link
                    to="#"
                    onClick={(e) => factorySelect(fac)}
                    key={index}
                    className={`text-reset mw-factory-item ${isSelected ? "active" : ""}`}
                  >
                    <span className="mw-factory-av">{(fac.name || "?").charAt(0).toUpperCase()}</span>
                    <span className="mw-factory-name">{fac.name}</span>
                    {isSelected && <i className="mdi mdi-check-circle mw-factory-check" />}
                  </Link>
                )
              })}
          </SimpleBar>
        </DropdownMenu>
      </Dropdown>
    </>
  )
}

export default withTranslation()(FactoryDropdown)

FactoryDropdown.propTypes = {
  t: PropTypes.any,
}
